import React from 'react';
import Footer from '../component/footer/Footer';
import Header from '../component/header/Header';
import Rows from '../component/rows/Rows';
import Banner from '../component/Banner/Banner.js';
function Home() {
  return (
    <>
      <Header />
      <Banner />
      <Rows />
    
      <Footer />
    </>
  );
}

export default Home;
